import React, { useEffect, useRef, useState } from "react";
import instance from "../../../../axios/instance";
import { getToken } from "../../../../utils/token";
import { useLoaderData } from "react-router-dom";
import TelehealthConsentForm from "../../../../components/modals/forms/TelehealthConsentForm";
import TelehealthCounselingForm from "../../../../components/modals/forms/TelehealthCounselingForm";
import TelehealthPermissionForm from "../../../../components/modals/forms/TelehealthPermissionForm";
import WeightLossConsentForm from "../../../../components/modals/forms/WeightConsentForm";

export const formsLoader = async ({ params }) => {
  const token = getToken();
  const facility = await instance.get(`/doctor/facility`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const form = await instance.get(`/doctor/forms/${params.id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return { form: form.data, facility: facility.data };
};

const FormsPage = () => {
  let { form, facility } = useLoaderData();
  const [currentForm, setCurrentForm] = useState(null);

  useEffect(() => {
    console.log(currentForm)
  }, [currentForm]);

  return (
    <>
      <div className="px-7 py-10">
        <div className="flex justify-between items-center">
          <div className="font-bold text-[16px]">Patient Forms</div>
        </div>

        {form.created_at ? (
          <div className="grid grid-cols-2 py-2 gap-x-5 gap-y-5">
            <FormPreviewItem
              form={form}
              formName={"Telehealth Consent Form"}
              setCurrentForm={setCurrentForm}
              index={0}
            />
            <FormPreviewItem
              form={form}
              formName={"Telehealth Counseling Consent Form"}
              setCurrentForm={setCurrentForm}
              index={1}
            />
            <FormPreviewItem
              form={form}
              formName={"Telehealth Permission Form"}
              setCurrentForm={setCurrentForm}
              index={2}
            />
            <FormPreviewItem
              form={form}
              formName={"Weight Loss Program Consent Form"}
              setCurrentForm={setCurrentForm}
              index={3}
            />
          </div>
        ) : (
          <div className="py-2 text-sm">
            There are no forms for this patient
          </div>
        )}
      </div>
      {currentForm !== null && (
        <ConsentForms
          clinic={facility}
          onClose={() => setCurrentForm(null)}
          patient={form.patient}
          forms={form}
          currentForm={currentForm}
          setCurrentForm={setCurrentForm}
        />
      )}
    </>
  );
};

export default FormsPage;

const ConsentForms = ({
  clinic,
  onClose,
  patient,
  forms,
  currentForm,
  setCurrentForm,
}) => {
  const sigPad = useRef(null);

  const formComponents = [
    <TelehealthConsentForm
      clinic={clinic}
      patient={patient}
      signature={JSON.parse(forms.consent_form_signature)}
      sigPad={sigPad}
      viewOnly={true}
      date={forms.created_at}
    />,
    <TelehealthCounselingForm
      patient={patient}
      signature={JSON.parse(forms.counseling_form_signature)}
      sigPad={sigPad}
      signedBy={forms.counseling_form_signed_by}
      relationship={forms.counseling_form_relationship}
      viewOnly={true}
      date={forms.created_at}
    />,
    <TelehealthPermissionForm
      patient={patient}
      signature={JSON.parse(forms.permission_form_signature)}
      sigPad={sigPad}
      signedBy={forms.permission_form_signed_by}
      relationship={forms.permission_form_relationship}
      viewOnly={true}
      date={forms.created_at}
    />,
    <WeightLossConsentForm
      clinic={clinic}
      patient={patient}
      signature={JSON.parse(forms.weight_form_signature)}
      sigPad={sigPad}
      viewOnly={true}
      date={forms.created_at}
    />,
  ];

  return (
    <div className="fixed inset-0 bg-white z-[100]">
      <div className="overflow-y-scroll max-h-[85vh] md:max-h-[90vh]">
        {formComponents[currentForm]}
      </div>
      <div className="absolute bottom-0 w-full bg-gray-100 px-6 py-3 flex flex-col md:flex-row md:justify-end items-center gap-x-4 gap-y-4">
        <button
          className="w-full md:w-fit px-4 py-3 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
          onClick={onClose}
        >
          Close
        </button>
        <div className="w-full md:max-w-[400px]">
          <button
            className="bg-primary hover:opacity-70 duration-300 ease-in-out rounded-md w-[180px] text-white py-3 flex gap-x-2 items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-secondary"
            onClick={currentForm >= 3 ? onClose : () => setCurrentForm((c) => c + 1)}
          >
            {currentForm >= 3 ? "Close" : "Next"}
          </button>
        </div>
      </div>
    </div>
  );
};

const FormPreviewItem = ({ form, formName, setCurrentForm, index }) => {
  return (
    <div className="border-gray-300 border rounded-md p-4">
      <h3 className="font-medium mb-3 text-lg">{formName}</h3>
      <p className="text-sm text-gray-600 mb-2">
        {new Date(form.created_at).toDateString()}
      </p>
      <div className="gap-y-4 gap-x-3 mt-5">
        <button
          type="button"
          onClick={() => setCurrentForm(index)}
          className="bg-primary hover:opacity-70 duration-300 ease-in-out text-sm rounded-md w-[180px] text-white py-3 flex gap-x-2 items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-secondary"
        >
          Open Form
        </button>
      </div>
    </div>
  );
};
